import { Component, Input } from '@angular/core';

import { clienteCarteiraTipoProjetada, clienteCarteiraTipoRealizada } from '../../../cliente-carteira/tipo';

@Component({
    selector: 'sgt-cliente-analise-mercado-projecao-progress',
    templateUrl: './cliente-analise-mercado-projecao-progress.component.html',
    styleUrls: ['./cliente-analise-mercado-projecao-progress.component.less']
})
export class ClienteAnaliseMercadoProjecaoProgressComponent {
    tipoCarteiraProjetada = clienteCarteiraTipoProjetada;
    tipoCarteiraRealizada = clienteCarteiraTipoRealizada;

    /** Título para identificar a projeção */
    @Input() title = null;

    /** Se controla lançamentos por quantidade */
    @Input() controleQuantidade: boolean;
    /** Se controla lançamentos por peso */
    @Input() controlePeso: boolean;
    /** Se controla lançamentos por valor */
    @Input() controleValor: boolean;

    // Projetado
    /** Quantidade Projetada */
    @Input() quantidadeProjetada: number;
    /** Peso Projetado */
    @Input() pesoProjetado: number;
    /** Valor Projetado */
    @Input() valorProjetado: number;

    // Realizado
    /** Quantidade Realizada */
    @Input() quantidadeRealizada: number;
    /** Percentual da quantidade realziada sobre a quantidade projetada */
    @Input() quantidadeRealizadaPerc: number;
    /** Peso Realizado */
    @Input() pesoRealizado: number;
    /** Percentual do peso realizado sobre o peso projetado */
    @Input() pesoRealizadoPerc: number;
    /** Valor Realizado */
    @Input() valorRealizado: number;
    /** Percentual do valor realizado sobre o valor projetado */
    @Input() valorRealizadoPerc: number;
}
